(function() {
  var form = document.querySelector('[data-unimech-predictive-search]');

  if (!form) {
    return;
  }

  var input = form.querySelector('input[type="search"]');
  var panel = form.querySelector('.unimech-predictive-search');
  var defaultQuery = 'valve';
  var popularSearches = ['butterfly valve', 'gate valve', 'check valve', 'pressure gauge', 'grooved valve', 'fire protection'];
  var debounceTimer = null;
  var activeController = null;
  var lastQuery = '';
  var productCache = {};

  if (!input || !panel) {
    return;
  }

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function searchUrl(query) {
    return shopRoot() + 'search?q=' + encodeURIComponent(query || '');
  }

  function showPanel() {
    panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('unimech-search-open');
    suppressDoofinder();
  }

  function hidePanel() {
    panel.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('unimech-search-open');
  }

  function setPanel(html) {
    panel.innerHTML = html;
    showPanel();
  }

  function suppressDoofinder() {
    [
      '.dfd-root',
      '.dfd-fullscreen',
      '.dfd-layer',
      '.dfd-results',
      '.dfd-searchbox',
      '.doofinder',
      '[id*="doofinder"]',
      '[class*="doofinder"]'
    ].forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(element) {
        if (!panel.contains(element)) {
          element.style.setProperty('display', 'none', 'important');
          element.style.setProperty('visibility', 'hidden', 'important');
          element.style.setProperty('pointer-events', 'none', 'important');
        }
      });
    });
  }

  function productImage(product) {
    var image = product && (product.featured_image || product.image);

    if (!image) {
      return '';
    }

    if (typeof image === 'string') {
      return image;
    }

    return image.url || image.src || '';
  }

  function priceValue(value) {
    if (value && typeof value === 'object' && value.amount) {
      return value.amount;
    }

    return value || '';
  }

  function priceNumber(value) {
    var parsed = parseFloat(String(priceValue(value)).replace(/[^0-9.]/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function priceText(value) {
    var cleanValue = priceValue(value);

    if (!cleanValue) {
      return '';
    }

    if (typeof cleanValue === 'number') {
      return '$' + (cleanValue / 100).toFixed(2);
    }

    cleanValue = String(cleanValue);

    if (cleanValue.charAt(0) !== '$' && /^\d+(\.\d+)?$/.test(cleanValue)) {
      return '$' + cleanValue;
    }

    return cleanValue;
  }

  function productPriceHtml(product) {
    if (!product) {
      return '';
    }

    var price = product.price || product.price_min;
    var compareAt = product.compare_at_price || product.compare_at_price_min || product.compare_at_price_max;
    var priceLabel = priceText(price);
    var compareAtLabel = priceText(compareAt);

    if (!priceLabel) {
      return '';
    }

    if (compareAtLabel && priceNumber(compareAt) > priceNumber(price)) {
      return [
        '<span class="unimech-predictive-search__price">',
          '<s>' + escapeHtml(compareAtLabel) + '</s>',
          '<em class="is-sale">' + escapeHtml(priceLabel) + '</em>',
        '</span>'
      ].join('');
    }

    return '<span class="unimech-predictive-search__price"><em>' + escapeHtml(priceLabel) + '</em></span>';
  }

  function productHandle(product) {
    var url = product && product.url ? product.url : '';
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function centsPriceText(value) {
    var cents = parseInt(value, 10);

    if (!Number.isFinite(cents) || cents <= 0) {
      return '';
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function bestVariant(productJson) {
    var variants = productJson && productJson.variants ? productJson.variants : [];
    var saleVariant = variants.find(function(variant) {
      return variant.compare_at_price && variant.compare_at_price > variant.price;
    });

    return saleVariant || variants[0] || null;
  }

  function enrichProductPrice(product, card) {
    var handle = productHandle(product);
    var priceNode = card.querySelector('.unimech-predictive-search__price');

    if (!handle || !priceNode) {
      return;
    }

    function applyPrice(productJson) {
      var variant = bestVariant(productJson);

      if (!variant) {
        return;
      }

      var priceLabel = centsPriceText(variant.price);
      var compareAtLabel = centsPriceText(variant.compare_at_price);

      if (!priceLabel) {
        return;
      }

      if (compareAtLabel && variant.compare_at_price > variant.price) {
        priceNode.innerHTML = '<s>' + escapeHtml(compareAtLabel) + '</s><em class="is-sale">' + escapeHtml(priceLabel) + '</em>';
      } else {
        priceNode.innerHTML = '<em>' + escapeHtml(priceLabel) + '</em>';
      }
    }

    if (productCache[handle]) {
      applyPrice(productCache[handle]);
      return;
    }

    fetch(shopRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Product lookup failed');
        }

        return response.json();
      })
      .then(function(productJson) {
        productCache[handle] = productJson;
        applyPrice(productJson);
      })
      .catch(function() {});
  }

  function enrichVisiblePrices(products) {
    if (!Array.isArray(products)) {
      return;
    }

    var cards = panel.querySelectorAll('.unimech-predictive-search__product');
    products.forEach(function(product, index) {
      if (cards[index]) {
        enrichProductPrice(product, cards[index]);
      }
    });
  }

  function renderProduct(product) {
    var image = productImage(product);
    var price = productPriceHtml(product);
    var url = product.url || '#';

    return [
      '<a class="unimech-predictive-search__product" href="' + escapeHtml(url) + '" role="option">',
        '<span class="unimech-predictive-search__image">',
          image ? '<img src="' + escapeHtml(image) + '" alt="">' : '<span></span>',
        '</span>',
        '<span class="unimech-predictive-search__info">',
          '<strong>' + escapeHtml(product.title) + '</strong>',
          price,
        '</span>',
      '</a>'
    ].join('');
  }

  function queryText(query) {
    return query.text || query.styled_text || query;
  }

  function renderQuery(query) {
    var text = queryText(query);
    return '<a class="unimech-predictive-search__side-link" href="' + escapeHtml(searchUrl(text)) + '">' + escapeHtml(text) + '</a>';
  }

  function renderCollection(collection) {
    return '<a class="unimech-predictive-search__side-link" href="' + escapeHtml(collection.url || '#') + '">' + escapeHtml(collection.title) + '</a>';
  }

  function renderPopularSearch(term) {
    return '<button class="unimech-predictive-search__side-link" type="button" data-unimech-search-term="' + escapeHtml(term) + '">' + escapeHtml(term) + '</button>';
  }

  function renderSidebar(queries, collections) {
    var html = '';

    html += '<div class="unimech-predictive-search__filters">';
    html += '<div class="unimech-predictive-search__filter-block">';
    html += '<p>Popular searches</p>';
    html += popularSearches.map(renderPopularSearch).join('');
    html += '</div>';

    if (queries.length) {
      html += '<div class="unimech-predictive-search__filter-block">';
      html += '<p>Suggestions</p>';
      html += queries.slice(0, 5).map(renderQuery).join('');
      html += '</div>';
    }

    if (collections.length) {
      html += '<div class="unimech-predictive-search__filter-block">';
      html += '<p>Collections</p>';
      html += collections.slice(0, 5).map(renderCollection).join('');
      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  function renderResults(data, query, isDefault) {
    var results = data && data.resources && data.resources.results ? data.resources.results : {};
    var products = results.products || [];
    var queries = results.queries || [];
    var collections = results.collections || [];
    var resultTitle = isDefault ? 'Recommended products' : 'Results: ' + products.length;
    var html = '';

    html += '<div class="unimech-predictive-search__backdrop" data-unimech-search-close></div>';
    html += '<div class="unimech-predictive-search__dialog">';
    html += '<div class="unimech-predictive-search__topbar">';
    html += '<strong>' + escapeHtml(resultTitle) + '</strong>';
    html += '<button class="unimech-predictive-search__close" type="button" aria-label="Close search" data-unimech-search-close><span aria-hidden="true">Close</span></button>';
    html += '</div>';
    html += '<div class="unimech-predictive-search__body">';
    html += renderSidebar(queries, collections);
    html += '<div class="unimech-predictive-search__results">';

    if (products.length) {
      html += '<div class="unimech-predictive-search__grid">';
      html += products.map(renderProduct).join('');
      html += '</div>';
    } else {
      html += '<div class="unimech-predictive-search__empty">No quick results. Press Enter to search the full catalog.</div>';
    }

    if (query && query !== defaultQuery) {
      html += '<a class="unimech-predictive-search__all" href="' + escapeHtml(searchUrl(query)) + '">View all results for "' + escapeHtml(query) + '"</a>';
    }

    html += '</div></div></div>';
    setPanel(html);
    enrichVisiblePrices(products);
  }

  function search(query, isDefault) {
    var cleanQuery = (query || '').trim();

    if (!cleanQuery) {
      cleanQuery = defaultQuery;
      isDefault = true;
    }

    if (cleanQuery === lastQuery && !panel.hidden) {
      return;
    }

    lastQuery = cleanQuery;

    if (activeController) {
      activeController.abort();
    }

    activeController = new AbortController();
    setPanel([
      '<div class="unimech-predictive-search__backdrop" data-unimech-search-close></div>',
      '<div class="unimech-predictive-search__dialog">',
        '<div class="unimech-predictive-search__empty">Searching...</div>',
      '</div>'
    ].join(''));

    var params = [
      'q=' + encodeURIComponent(cleanQuery),
      'resources[type]=product,query,collection',
      'resources[limit]=10',
      'resources[limit_scope]=each',
      'resources[options][unavailable_products]=last',
      'resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag'
    ].join('&');

    fetch(shopRoot() + 'search/suggest.json?' + params, {
      headers: { 'Accept': 'application/json' },
      signal: activeController.signal
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Search failed');
        }

        return response.json();
      })
      .then(function(data) {
        renderResults(data, cleanQuery, isDefault);
      })
      .catch(function(error) {
        if (error.name === 'AbortError') {
          return;
        }

        setPanel([
          '<div class="unimech-predictive-search__backdrop" data-unimech-search-close></div>',
          '<div class="unimech-predictive-search__dialog">',
            '<div class="unimech-predictive-search__empty">Quick search is unavailable. Press Enter to search.</div>',
          '</div>'
        ].join(''));
      });
  }

  function queueSearch() {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function() {
      suppressDoofinder();
      search(input.value, !input.value.trim());
    }, 180);
  }

  input.addEventListener('focus', function() {
    search(input.value, !input.value.trim());
  });

  input.addEventListener('input', queueSearch);

  input.addEventListener('keyup', suppressDoofinder);

  input.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      hidePanel();
    }
  });

  panel.addEventListener('click', function(event) {
    var closeTarget = event.target.closest('[data-unimech-search-close]');
    var termTarget = event.target.closest('[data-unimech-search-term]');

    if (closeTarget) {
      hidePanel();
      return;
    }

    if (termTarget) {
      input.value = termTarget.getAttribute('data-unimech-search-term') || '';
      search(input.value, false);
      input.focus();
    }
  });

  document.addEventListener('click', function(event) {
    if (!form.contains(event.target) && !panel.contains(event.target)) {
      hidePanel();
    }
  });
})();
